import { Button } from '@pms-digital/design-system';
import { CadreAnalyse } from './cadre-analyse';

interface ServiceIndisponibleProps {
  onReessayer: () => void;
  /** A new attempt is under way: the button waits. */
  enCours: boolean;
}

/**
 * Sober message when the service cannot be reached or answers something unexpected. It has its
 * `h1` (B10, #13: RGAA 9.1) and the same form as the one of the result (`ErreurService`).
 */
export function ServiceIndisponible({ onReessayer, enCours }: ServiceIndisponibleProps) {
  return (
    <CadreAnalyse titre="Service indisponible">
      <div role="alert" className="flex flex-col items-start gap-6">
        <div className="flex flex-col gap-2">
          <h1 className="font-light text-h2 leading-[1.2]">Le service est indisponible.</h1>
          <p className="text-body text-gray-700">L'analyse n'a pas pu être lue.</p>
        </div>
        <Button type="button" variant="primary" disabled={enCours} onClick={onReessayer}>
          réessayer
        </Button>
      </div>
    </CadreAnalyse>
  );
}
